import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=fb6842b6"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=fb6842b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports